import FreightManagementContainer from './FreightManagementContainer';
import FreightAllList from './FreightAllList';
import FreightDivList from './FreightDivList';
export const FreightIndex = {
  FreightManagementContainer,
  FreightAllList,
  FreightDivList,
};
